import React from 'react';
import {
  IAvailableWorkshiftData,
  ILogos,
  PharmacistLegendVariant,
  TimeFormat,
  convertToDecimals,
} from '@pharmaplan/common';
import { timeString } from '../../../helpers/Functions';
import { getHoursDiff } from '../../Modals/WorkshiftDetails/utils';
import strings from '../../../localization';
import { LocationText } from './AvailableWorkshifts';
import { getDayMonthDateYear } from '../../Reports/helpers';
import CustomChip from '../../common/CustomChip';

interface IConfigBuilder {
  startDate: string;
  endDate: string;
  timeFormat: TimeFormat;
  city: string;
  software: string;
  showStatus?: boolean;
  isRequested?: boolean;
}

export const configBuilder = ({
  startDate,
  endDate,
  timeFormat,
  city,
  software,
  showStatus,
  isRequested,
}: IConfigBuilder) => {
  const date = getDayMonthDateYear(startDate);
  const time = timeString(startDate, endDate, timeFormat);
  const hours = `${time} (${getHoursDiff(startDate, endDate)}${strings.hoursAbbreviation})`;

  const eventType = isRequested
    ? PharmacistLegendVariant.requested
    : PharmacistLegendVariant.workshift;
  const eventLabel = isRequested
    ? strings.requestedWorkshift
    : strings.availableWorkshift;

  return [
    { key: '0', value: date },
    { key: '1', value: strings.formatString(strings.timeColon, hours) },
    // {
    //   key: '1.5', value: `${strings.postedOn}: ${shiftCreateFormat}`,
    // },
    city && { key: '2', value: <LocationText label={city} /> },
    { key: '3', value: software },
    {
      key: '4',
      value: showStatus && <CustomChip label={eventLabel} type={eventType} />,
    },
  ].filter(Boolean) as Array<{
    key: string;
    value: string | string[] | JSX.Element;
  }>;
};

export const workshiftListBuilder = (
  event: Array<IAvailableWorkshiftData>,
  allLogos: Array<ILogos>,
  timeFormat: TimeFormat,
  showStatus: boolean,
) =>
  event.map((item) => {
    const {
      name,
      hourlyRate,
      logoId,
      startDate,
      endDate,
      city,
      workshiftId,
      pharmacistHourlyRate,
      pharmacyHourlyRate,
      pharmacyId,
      softwareName,
      isRequested,
      replacementType,
      isAutoSyncRecord,
    } = item;

    const avatar = allLogos.find((logo) =>
      logo.logoId === logoId)?.image;

    return {
      ...item,
      config: configBuilder({
        startDate,
        endDate,
        timeFormat,
        city,
        software: softwareName,
        showStatus,
        isRequested,
      }),
      title: name,
      hourlyRate: convertToDecimals(hourlyRate),
      avatar,
      workshiftId,
      pharmacyId,
      pharmacistHourlyRate: convertToDecimals(pharmacistHourlyRate),
      pharmacyHourlyRate: convertToDecimals(pharmacyHourlyRate),
      startDate,
      endDate,
      softwareName,
      isRequested,
      replacementType,
      isAutoSyncRecord,
    };
  });

type genericParams = Array<string | number | React.ReactNode>;

export const genericConfigBuilder = (...args: genericParams) =>
  args.map((item, index) =>
    ({
      key: index.toString(),
      value: item,
    }));
